import Cookies from 'js-cookie';
import Variable from '../../constants/constants.json';

const { handleExcception } = require('../../api/sentryExceptionHandler');
const { LOGIN, LOGIN_ERROR, LOGOUT } = require('../Constants/login.constants');
const { createRequest } = require('../../api/client');

export const login = (data, history) => async (dispatch) => {
    const options = {
        url: `${Variable.backendUrl}/user/login`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: {
            email: data.email,
            password: data.password
        }
    };
    try {
        const { data } = await createRequest(options);
        if (data) {
            dispatch({
                type: LOGIN,
                data
            });
            if (['searchunify.com', 'grazitti.com'].includes(data.email.split('@')[1])) {
                history.push('/app/dashboard');
            } else {
                history.push('/status-page');
            }
        } else {
            dispatch({
                type: LOGIN_ERROR,
                data: 'Invalid email or password'
            });
        }
    } catch (err) {
        handleExcception(err);
        dispatch({
            type: LOGIN_ERROR,
            data: 'Connection error'
        });
    }
};

export const logout = (history) => async (dispatch) => {
    const options = {
        url: `${Variable.backendUrl}/user/logout`,
        method: 'GET'
    };
    try {
        const data = await createRequest(options);
        history.push('/');
        Cookies.remove('email');
        Cookies.remove('user_id');
        Cookies.remove('_csrf');
        Cookies.remove('tenantId');
        dispatch({
            type: LOGOUT,
            data
        });
    } catch (err) {
        handleExcception(err);
        console.log(err);
    }
};
